// Return the previous year column (5 = Four quarters columns + Year column)
const getPrevYearColumn = ({ columnIndex, column, alphabet }) => column.isParent && alphabet[columnIndex - 5];

export default getPrevYearColumn;
